__turbopack_context__.v({
  "allBtn": "main-sidebar-prematch-module-sass-module__5iFEcG__allBtn",
  "gamesCount": "main-sidebar-prematch-module-sass-module__5iFEcG__gamesCount" + " " + __turbopack_context__.i(488939)["gamesCount"],
  "popoverContent": "main-sidebar-prematch-module-sass-module__5iFEcG__popoverContent" + " " + __turbopack_context__.i(488939)["popoverContent"],
  "selected": "main-sidebar-prematch-module-sass-module__5iFEcG__selected",
  "subNav": "main-sidebar-prematch-module-sass-module__5iFEcG__subNav" + " " + __turbopack_context__.i(488939)["subNav"],
  "subNavItem": "main-sidebar-prematch-module-sass-module__5iFEcG__subNavItem" + " " + __turbopack_context__.i(488939)["subNavItem"],
});
